import moment from 'moment-timezone';

// Устанавливаем локальную зону времени
moment.locale('ru');
moment.tz.setDefault(moment.tz.guess());

export default moment; 
